import React, {useEffect} from "react";
import {Button, Result} from "antd";

const CompanyLicenceSuccessDialog = ({newLicence, goToLicences, addAnotherLicence, clearNewlyAddedLicence}) => {

    useEffect(() => {
        return () => {
            clearNewlyAddedLicence();
        }
    }, []);

    return <Result
        status="success"
        title={<span>Licence successfully issued</span>}
        subTitle="Licence successfully issued"
        extra={[
            <Button type="primary" key="console" onClick={addAnotherLicence}>
                Add Another Licence
            </Button>,
            <Button key='toLicences' onClick={goToLicences}>Go back to Licences</Button>,
        ]}
    />
};

export default CompanyLicenceSuccessDialog;